module.exports = "/_next/static/images/EnableDataDrivenDecisionMaking@2x-904fabbbdfcb96762e154ffe7313530c.webp";